import React from "react";
import Typography from "@mui/material/Typography";
import { Container } from "react-bootstrap";
import { FormRow } from "./FormRow";

export interface FormItem {
  label: string;
  required?: boolean;
  optional?: boolean;
  value: string | React.ReactNode;
  action?: React.ReactNode | undefined;
}

interface Props {
  classNames?: string;
  dataList?: FormItem[];
  emptyMessage?: string;
}

export function FormContainer(props: React.PropsWithChildren<Props>) {
  const displayActionColumn = props.dataList?.some((dataItem: FormItem) => dataItem.action !== undefined);

  if ((props.dataList && props.dataList.length > 0) || props.children)
    return (
      <Container fluid className={props.classNames}>
        {props.dataList?.map((dataItem: FormItem) => (
          <FormRow
            key={`dataDisplayRow-${dataItem.label}`}
            label={dataItem.label}
            value={dataItem.value}
            displayActionCell={displayActionColumn}
            action={dataItem.action}
            required={dataItem.required}
            optional={dataItem.optional}
          />
        ))}

        {props.children}
      </Container>
    );
  else
    return (
      <Typography variant="body2" color="textSecondary">
        {props.emptyMessage}
      </Typography>
    );
}
